// Lista de marcas comuns de filamentos
export const COMMON_BRANDS = [
  'Prusament', 'eSUN', 'SUNLU', 'Polymaker', 'Hatchbox', 'Overture', 'Creality', 'Geeetech',
  'Anycubic', 'MatterHackers', 'ColorFabb', '3D Fuel', 'SainSmart', 'Atomic Filament', 'Fiberlogy',
  'Fillamentum', 'FormFutura', 'Devil Design', 'BASF Ultrafuse', 'Orient Express', 'Spectrum',
  'Snapmaker', 'AMOLEN', 'Amazon Basics', 'Ziro', 'Tronxy', 'Monoprice', 'Smartfil', 'RS Pro',
  'XYZprinting', 'Ultimaker', 'Raise3D', 'PrintaMent', 'Prusa', 'CR-3D', 'Kodak', 'Robo3D'
];

export const brandOptions = COMMON_BRANDS.map(b => ({ value: b, label: b }));